import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { ADMIN_ROLES } from "../utils/role";
import { pendingApprovalsCount } from "../api/hr";

// عدّاد الطلبات المعلّقة (للأدمن فقط) — لقطة عامة + تحديث كل دقيقة وعند حدث موافقة/رفض.
let SNAP = 0;

export const useApprovalsCount = () => {
  const { user } = useAuth();
  const [count, setCount] = useState(SNAP);
  const isAdmin = ADMIN_ROLES.includes(user?.role);

  useEffect(() => {
    if (!isAdmin) return undefined;
    let alive = true;
    const load = () =>
      pendingApprovalsCount()
        .then((d) => { if (alive) { SNAP = d.count || 0; setCount(SNAP); } })
        .catch(() => {});
    load();
    const timer = setInterval(load, 60000);
    window.addEventListener("helcoo:approvals-refresh", load);
    return () => { alive = false; clearInterval(timer); window.removeEventListener("helcoo:approvals-refresh", load); };
  }, [isAdmin]);

  return isAdmin ? count : 0;
};
